import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FirebaseAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Simple redirect to home after Firebase auth callback
    navigate("/home");
  }, [navigate]);

  return null; // No UI needed, just redirect
};

export default FirebaseAuthCallback;
